module.exports = __webpack_public_path__ + "static/media/SMA_Inverter.6ade3abe.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SMA_Inverter.jpg
// module id = 1109
// module chunks = 0